import { render, staticRenderFns } from "./VideoPlayer.vue?vue&type=template&id=ca08f266&scoped=true"
import script from "./VideoPlayer.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoPlayer.vue?vue&type=script&setup=true&lang=js"
import style0 from "./VideoPlayer.vue?vue&type=style&index=0&id=ca08f266&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca08f266",
  null
  
)

export default component.exports